/**
 * Translation configuration constants
 */

import { LanguageConfig, TranslationConfig } from '../models/Translation';

export const SUPPORTED_LANGUAGES: LanguageConfig[] = [
  {
    code: 'fr',
    name: 'Français',
    flag: '🇫🇷',
    isDefault: true,
  },
  {
    code: 'en',
    name: 'English',
    flag: '🇬🇧',
    isDefault: false,
  },
  {
    code: 'es',
    name: 'Español',
    flag: '🇪🇸',
    isDefault: false,
  },
  {
    code: 'ro',
    name: 'Română',
    flag: '🇷🇴',
    isDefault: false,
  },
  {
    code: 'de',
    name: 'Deutsch',
    flag: '🇩🇪',
    isDefault: false,
  },
  {
    code: 'sl',
    name: 'Slovenščina',
    flag: '🇸🇮',
    isDefault: false,
  },
];

export const TRANSLATION_CONFIG: TranslationConfig = {
  defaultLanguage: 'fr',
  fallbackLanguage: 'fr',
  availableLanguages: SUPPORTED_LANGUAGES,
  translationPath: '/assets/i18n/',
};

export const LANGUAGE_STORAGE_KEY = 'bedici_language_preference';

export const DEFAULT_LANGUAGE_CODE = 'fr';
export const FALLBACK_LANGUAGE_CODE = 'fr';

/**
 * Language codes that are supported by the application
 */
export type SupportedLanguageCode = 'fr' | 'en' | 'es' | 'ro' | 'de' | 'sl';

/**
 * Check if a language code is supported
 */
export function isSupportedLanguage(code: string): code is SupportedLanguageCode {
  return SUPPORTED_LANGUAGES.some((lang) => lang.code === code);
}

/**
 * Get language configuration by code
 */
export function getLanguageConfig(code: string): LanguageConfig | undefined {
  return SUPPORTED_LANGUAGES.find((lang) => lang.code === code);
}

/**
 * Get default language configuration
 */
export function getDefaultLanguageConfig(): LanguageConfig {
  return SUPPORTED_LANGUAGES.find((lang) => lang.isDefault) || SUPPORTED_LANGUAGES[0];
}
